const SUBMITTED_INTERMEDIATE_INVOICE_STATUSES = ["Awaiting Audit", "Approved", "Declined"] as const;

export type IntermediateInvoiceLike = {
  invoice_type?: string;
  invoice_status?: string;
};

export function hasSubmittedIntermediateInvoice(invoices: IntermediateInvoiceLike[] | undefined): boolean {
  if (!invoices?.length) {
    return false;
  }

  return invoices.some(
    (invoice) =>
      invoice.invoice_type === "intermediate_invoice" &&
      SUBMITTED_INTERMEDIATE_INVOICE_STATUSES.includes(
        invoice.invoice_status as (typeof SUBMITTED_INTERMEDIATE_INVOICE_STATUSES)[number],
      ),
  );
}
